import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UserService} from '../../../services/user/user.service';
import {UntypedFormBuilder, UntypedFormGroup, ValidatorFn, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../../services/auth/auth.service';
import {NotificationService} from '../../../services/common/notification.service';

const passwordValidator: ValidatorFn = (fg: UntypedFormGroup) => {
  const pw = fg.get('newPassword').value;
  const pw2 = fg.get('newPasswordRepeated').value;
  if (pw !== null && pw2 !== null && fg.get('newPassword').touched && fg.get('newPasswordRepeated').touched) {
    if (pw !== pw2) {
      fg.get('newPassword').setErrors({mismatching: true});
      return {mismatching: true};
    }
  }
  if (pw !== null && pw2 !== null) {
    if (pw === pw2) {
      fg.get('newPassword').setErrors({mismatching: null});
      fg.get('newPassword').updateValueAndValidity({onlySelf: true, emitEvent: false});
      return null;
    }
  }
  return null;
};

export interface DialogData {
  id: number;
}

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    standalone: false
})
export class ChangePasswordComponent implements OnInit {

  id: number;
  hideCurrentPw: boolean;
  hideNewPw: boolean;
  passwordFormGroup: UntypedFormGroup;
  submit = false;

  constructor(@Inject(MAT_DIALOG_DATA) public injectedData: DialogData,
              private dialogRef: MatDialogRef<ChangePasswordComponent>,
              private formBuilder: UntypedFormBuilder,
              private notificationService: NotificationService,
              private route: ActivatedRoute,
              public authService: AuthService,
              private router: Router,
              private userService: UserService) {
    this.id = this.injectedData.id;
    this.hideCurrentPw = true;
    this.hideNewPw = true;
  }

  ngOnInit(): void {
    this.passwordFormGroup = this.formBuilder.group({
      currentPassword: ['', [Validators.required, Validators.minLength(8), Validators.nullValidator, Validators.maxLength(255)]],
      newPassword: ['', [Validators.required, Validators.minLength(8), Validators.nullValidator, Validators.maxLength(255)]],
      newPasswordRepeated: ['', [Validators.required, Validators.minLength(8), Validators.nullValidator, Validators.maxLength(255)]]
    }, {
      validators: [passwordValidator]
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  changePassword(): void {
    if (this.passwordFormGroup?.valid) {
      const currentPw = this.passwordFormGroup.controls.currentPassword?.value;
      const newPw = this.passwordFormGroup.controls.newPassword?.value;
      this.userService.changePassword(currentPw, newPw, this.id).subscribe(() => {
        this.notificationService.openSnackBar('Das Passwort wurde zurückgesetzt.');
        this.authService.logoutUser();
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate(['./'], {relativeTo: this.route});
        this.dialogRef.close();
      }, error => {
        this.notificationService.openSnackBar(error);
      });
    }
  }
}
